import * as actions from "../actions/Type";
const intialState = {
  property: {},
  list_of_sell_property: [],
  list_of_rent_property: [],
  view_sell_detail: {},
  view_rent_detail: {},
  update_property_sell: {},
  update_property_rent: {},
  list_of_required_property: [],
  list_of_required_property_rent: [],
  view_required_detail: {},
  required_property_rent: {},
  list_of_required_property: [],
  // loading
  require_status: false,
  // CUSTOMER DETAIL
  list_customer: [],
  view_customer_obj: {},
};
const PropertyReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.GET_LIST_PROPERTY_SELL:
      return {
        ...state,
        list_of_sell_property: action.payload,
      };

    case actions.GET_LIST_PROPERTY_RENT:
      return {
        ...state,
        list_of_rent_property: action.payload,
      };
    case actions.VIEW_DETAIL_SELL:
      return {
        ...state,
        view_sell_detail: action.payload,
      };
    case actions.VIEW_DETAIL_RENT:
      return {
        ...state,
        view_rent_detail: action.payload,
      };
    case actions.UPDATEING_PROPERTY_STATUS:
      return {
        ...state,
      };
    case actions.DELETE_PROPERTY:
      return {
        ...state,
      };
    case actions.GET_LIST_PROPERTY_REQUIRED:
      return {
        ...state,
        list_of_required_property: action.payload,
        require_status: action.require_status,
      };
    case actions.GET_DETAIL_OF_CUSTOMER:
      return {
        ...state,
        list_customer: action.payload,
      };

    case actions.CUSTOMER_VIEWED:
      return {
        ...state,
        view_customer_obj: action.payload,
      };
    case actions.CISTOMER_UPDATED:
      return {
        ...state,
      };
    case actions.CUSTOMER_DELETED:
      return {
        ...state,
        list_customer: state.list_customer.filter((el) => el._id !== action.id),
      };
    default:
      return { ...state };
  }
};

export default PropertyReducer;
